import { useEffect, useState } from "react";
import client, { extractError } from "@/api";

export default function AdminAccountingPage() {
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    client.get("/admin/accounting/summary").then((r) => setSummary(r.data)).catch((err) => setError(extractError(err)));
  }, []);
  if (error) return <div className="form-error">{error}</div>;
  if (!summary) return <div className="loading-block">Loading…</div>;
  const inr = (v) => `₹${(v || 0).toLocaleString("en-IN")}`;
  return (
    <div className="admin-accounting-page" data-testid="admin-accounting-page">
      <section className="signal-grid">
        <article className="signal-card accent">
          <p className="card-label">TOTAL FACILITATOR FEES</p>
          <h3 data-testid="total-fees">{inr(summary.total_facilitator_fees)}</h3>
          <span>Fee + GST across every settled trade</span>
        </article>
        <article className="signal-card">
          <p className="card-label">THIS MONTH</p>
          <h3 data-testid="fees-this-month">{inr(summary.fees_this_month)}</h3>
          <span>New fee accrual</span>
        </article>
        <article className="signal-card">
          <p className="card-label">PENDING INVOICING</p>
          <h3 data-testid="pending-invoicing">{summary.fees_pending_invoicing}</h3>
          <span>Fees waiting to be issued</span>
        </article>
        <article className="signal-card">
          <p className="card-label">ISSUED INVOICES</p>
          <h3 data-testid="issued-count">{summary.invoices_issued}</h3>
          <span>Currently active</span>
        </article>
      </section>
      <section className="credit-hero compact">
        <div className="credit-stats-row">
          <div><p className="eyebrow">UNPAID AMOUNT</p><strong>{inr(summary.unpaid_amount)}</strong></div>
          <div><p className="eyebrow">PAID AMOUNT</p><strong>{inr(summary.paid_amount)}</strong></div>
          <div><p className="eyebrow">OVERDUE COUNT</p><strong>{summary.overdue_count}</strong></div>
        </div>
      </section>
      <section className="foundation-band">
        <div>
          <p className="eyebrow">RECONCILIATION</p>
          <h2>Facilitator fees are separate from Barter Credits</h2>
          <p>Fees are billed to buyers as a monetary INR obligation. Barter Credits track the trade value between buyer and seller. The two ledgers do not overlap.</p>
        </div>
      </section>
    </div>
  );
}
